import { moneyMask } from '@/app/utils/formatMoneyValue'
import { BasicInput } from '@/view/components/BasicInput'
import { useFormContext } from 'react-hook-form'
import { FilterFormData } from './FilterReports'

export default function Values() {
  const {
    register,
    formState: { errors },
  } = useFormContext<FilterFormData>()
  return (
    <>
      <h2 className="font-medium text-black04">Valor</h2>
      <div className="flex items-center gap-2">
        <BasicInput
          {...register('minValue')}
          className="mt-2 h-11 w-[152px]"
          placeholder="R$"
          label="De"
          onInput={moneyMask}
          error={errors.minValue?.message}
        />

        <BasicInput
          {...register('maxValue')}
          className="mt-2 h-11 w-[152px]"
          placeholder="R$"
          label="Até"
          onInput={moneyMask}
          error={errors.maxValue?.message}
        />
      </div>
    </>
  )
}
